export default "/images/vendor/flag-icon-css/flags/4x3/ta.svg?56f55773ec3ffb245496dcf6c6ea32dd";